<template>
  <div class="page_header--search">
    <div class="flex flex-vertical-center">
      <form-field-input
        class="mb-0 flex-grow"
        ref="searchInput"
        placeholder="search leads..."
        v-model="searchData.search_term"
        @keyup.enter.native="searchRecords"
        @keyup.esc.native="cancelSearch"
        :loading="isGettingSearchResult"
        expanded
      ></form-field-input>
      <button-icon
        class="page_header--search--button"
        icon="search"
        color="is-secondary"
        @click="searchRecords"
      ></button-icon>
    </div>

    <div v-if="searchResults && searchData.search_term" class="page_header--search--results">
      <p v-show="searchResults.length === 0" class="page_header--search--results--none">No leads found</p>

      <page-header-search-record
        v-for="record in searchResults"
        :record="record"
        :key="record.id"
      ></page-header-search-record>
    </div>
  </div>
</template>

<script>
import PageHeaderSearchRecord from "./PageHeaderSearchRecord";

export default {
  name: "PageHeaderSearch",
  components: {PageHeaderSearchRecord},
  data() {
    return {
      isSearching: false,
      isGettingSearchResult: false,
      searchData: {
        search_term: ""
      },
      searchResults: null
    };
  },
  methods: {
    activateSearch() {
      this.isSearching = true;
      this.$refs.searchInput.focus();
      this.$emit("searching");
      this.$root.$emit("searching");
    },
    searchRecords() {
      if (this.searchData.search_term === null || this.searchData.search_term === "") return;

      this.isGettingSearchResult = true;

      this.$api.records.searchWithContacts(this.searchData).then((res) => {
        this.searchResults = res.data;
      }).finally(() => {
        this.isGettingSearchResult = false;
      });
    },
    cancelSearch(el) {
      if (el.tagName === "INPUT") {
        el.blur();
      }

      this.searchData.search_term = "";
      this.searchResults = null;
      this.isSearching = false;
      this.$emit("cancel");
      this.$root.$emit("search-cancel");
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";


::v-deep .material-icons.is-secondary {
  color: inherit !important;
}

.page_header--search {
  position: relative;

  &--button {
    border: 1px solid $border !important;
    border-left: 0 !important;
    border-radius: 0 !important;
    background-color: $white !important;

    &:hover {
      border-color: $secondary !important;
      background-color: $secondary !important;
      color: $white !important;
    }

    &:focus {
      border: 1px solid $secondary !important;
      color: $secondary !important;
    }
  }

  &--results {
    position: absolute;
    top: 45px;
    right: 0;
    z-index: 1000;
    overflow-y: auto;
    max-height: 80vh;
    width: 300px;
    padding: 10px;
    border: 1px solid $border;
    background-color: #fcfdfe;
    border-radius: 5px;

    @media (max-width: 400px) {
      width: 100%
    }
  }

  &--results--none {
    text-align: center;
    padding: 10px 0;
  }
}
</style>
